import { withStyles } from '@material-ui/core/styles'
import React from 'react'
import TableRow from './TableRow'

const styles = theme => ({
  fieldset: {
    margin: '1rem 0 0',
    '& > legend': {
      marginBottom: '10px'
    }
  },
  table: {
    width: '100%',
    color: 'currentColor'
  },
  tableSubItem: {
    paddingLeft: '13px'
  },
  tableLegend: {
    width: '73px',
    color: 'rgba(0, 0, 0, 0.38)',
    textAlign: 'center',
    fontSize: '.75rem'
  }
})

const PermissionsTable = props => {
  const { classes, sectionTitle, permissions, functionalities, onChange, readOnly } = props

  const getFunctionalities = () => {
    return functionalities.reduce((prev, current) => {
      const currentPermission = permissions[current.alias] || {}
      return [
        ...prev,
        {
          ...current,
          ...currentPermission
        }
      ]
    }, [])
  }

  return (
    <fieldset className={classes.fieldset}>
      <table className={classes.table}>
        <tr>
          <td>{sectionTitle && <legend>{sectionTitle}</legend>}</td>
          <td className={classes.tableLegend}>Ler</td>
          <td className={classes.tableLegend}>
            <span>
              Criar /<br />Editar
            </span>
          </td>
          <td className={classes.tableLegend}>
            <span>
              Remover /<br />Restaurar
            </span>
          </td>
        </tr>

        {getFunctionalities().map((functionality, key) => {
          return (
            <TableRow
              key={key}
              functionality={functionality}
              onChange={onChange}
              readOnly={readOnly}
            />
          )
        })}
      </table>
    </fieldset>
  )
}

export default withStyles(styles)(PermissionsTable)



// WEBPACK FOOTER //
// ./src/components/PermissionsTable/index.js